'use client';
import dynamic from 'next/dynamic';
import MetaTags from '@/components/meta-tag/meta-tag';
import ProudCoSponsor from '@/components/common/proud-co-sponsor';

const ContactInfoPmigjcAnantam = dynamic(() => import('@/components/common/contact-info-pmigjc-anantam'));
const ContactFormAiml = dynamic(() => import('@/components/common/contact-form-aiml'));

const Page = () => {
    return (
        <>
            <MetaTags />
            <section className="section-py !pt-10 technology-herosection relative aiml-hero-section aiml-banner-video pmigjc-anantam-section">
                <div className="absolute inset-0 z-0">
                    <video playsInline autoPlay muted loop className="aimlvideo w-full h-full object-cover">
                        <source src="media/bg-ai-ml.mp4" type="video/mp4" />
                    </video>

                    {/* Gradient Overlay */}
                    <div className="absolute inset-0 pointer-events-none bg-video-gradient"></div>
                </div>

                <div className="container lg:container md:mx-auto">
                    <div>
                        <ProudCoSponsor />
                    </div>
                    <div className="row grid md:grid-cols-12 lg:grid-cols-12 relative z-[1] lg:gap-10 md:gap-10 sm:gap-6">
                        <ContactFormAiml />
                        <ContactInfoPmigjcAnantam />
                    </div>
                </div>
            </section>
        </>
    );
};

export default Page;
